<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GVDLhI/tc-custom/9781614755654.jpg?1699984883934" alt="This image is the cover for the book Tales of Dune"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tales of Dune
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Eight epic science fiction tales set in the breathtaking world of Dune.</b></p><p> Brian Herbert and Kevin J. Anderson have written thirteen international bestselling novels set in this epic universe. But the wealth of material leaves many side tales or interesting ideas that can be told, hors d’oeuvres to accompany the exotic main course. </p><p> Sometimes, a short story is exactly what’s needed. </p><p><i>Tales of Dune</i> collects eight of Herbert and Anderson’s Dune short stories, ranging from the period of the Butlerian Jihad, to the time of young Paul Atreides, to a story set during the events of the novel <i>Dune</i>, to the very end of Frank Herbert’s future history. </p><p> These are the missing pieces in the epic of Dune. </p><p> Includes the stories: </p><p><b>“Hunting Harkonnens”</b></p><p><b>“Whipping Mek”</b></p><p><b>“The Faces of a Martyr”</b></p><p><b>“Red Plague”</b></p><p><b>“Wedding Silk”</b></p><p><b>“A Whisper of Calandan Seas”</b></p><p><b>“Sea Child”</b></p><p><b>“Treasure in the Sand”</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Herbert
      </h2>
      
      <p class="authorDescription body article">Brian Herbert is the author of multiple New York Times bestsellers. He has won a number of literary honors including the New York Times Notable Book Award, and has been nominated for the highest awards in science fiction. After more than five years in development, he published Dreamer of Dune, a moving biography of his father (Frank Herbert) that was a Hugo Award finalist. His acclaimed novels include the Timeweb trilogy (Timeweb, The Web and the Stars, and Webdancers); The Stolen Gospels; The Lost Apostles; The Race for God; Sidney's Comet; Sudanna, Sudanna; and Man of Two Worlds (written with Frank Herbert).Kevin J. Anderson has published 140 books, 56 of which have been national or international bestsellers. He has written numerous novels in the Star Wars, X-Files, and DC Comics universes, as well as unique steampunk fantasy novels Clockwork Angels and Clockwork Lives, written with legendary rock drummer Neil Peart, based on the concept album by the band Rush. His original works include the Saga of Seven Suns series, the Terra Incognita fantasy trilogy, the Saga of Shadows trilogy, and his humorous horror series featuring Dan Shamble, Zombie PI. He has edited numerous anthologies, written comics and games, and the lyrics to two rock CDs. Anderson and his wife Rebecca Moesta are the publishers of WordFire Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Word Fire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9b63e24a